const laboTurnosInitialState = {
  laboTurnos: {
    loading: false,
    error: null,
    data: null,
    flgCambiarTurno: false,
    flgBuscarTurno: false,
  },
};

export default laboTurnosInitialState;
